/**
 * Youtube video module
 *
 * @author Naiqiao Liang (nliang@yext.com)
 */
goog.provide('yext.dam.assetselector.video');

goog.require('yext');
goog.require('yext.ajax');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
goog.require('yext.utils.youtube');
goog.require('yext.youtube');

yext.dam.assetselector.video.$selector = undefined;
yext.dam.assetselector.video.$preview = undefined;
yext.dam.assetselector.video.$previewMessage = undefined;
yext.dam.assetselector.video.$template = undefined;

/**
 * Initialize youtube video module
 */
yext.dam.assetselector.video.init = function() {
  yext.dam.assetselector.video.$selector = $('.js-asset-selector');
  yext.dam.assetselector.video.$preview = yext.dam.assetselector.video.$selector.find('.js-video-preview');
  yext.dam.assetselector.video.$previewMessage = yext.dam.assetselector.video.$selector.find('.js-video-preview-message');
  yext.dam.assetselector.video.$template = $('.js-video-edit-preview-template');

  yext.dam.assetselector.video.bindEnterVideo();
};

/**
 * Update youtube preview and also append video info
 * @param {string} url The url to fetch youtube preview
 */
yext.dam.assetselector.video.updatePreview = function(url) {
  var ytid = yext.youtube.parseIdFromUrl(url);
  var $preview = yext.dam.assetselector.video.$preview;
  var $previewMessage = yext.dam.assetselector.video.$previewMessage;

  if ($preview.data('ytid') !== ytid) {
    var iteration = $preview.data('iteration') + 1;
    $preview
      .data('iteration', iteration)
      .data('ytid', ytid);
    if (ytid) {
      $previewMessage.hide();
      $preview.html('<div class="video-preview-loading">' + yext.msg('Loading video details...') + '</div>');

      var onError = function() {
        yext.dam.assetselector.video.$selector.find('.js-add-asset').prop('disabled', true);
        $preview.html('<div class="video-preview-error">' + yext.msg('Could not load video details.') + '</div>');
      };
      yext.youtube.getVideosDetails([ytid], function(videos) {
        if (videos.length === 0) {
          onError();
          return;
        }

        if ($preview.data('iteration') !== iteration) {
          return;
        }
        try {
          var video = videos[0];
          if (video.id !== ytid) {
            throw new Error();
          }

          var html = yext.utils.youtube.fixupVideoTemplate(yext.dam.assetselector.video.$template.html(), video);
          $preview
            .html(html)
            .show();
          // enable add button
          yext.dam.assetselector.video.$selector.find('.js-add-asset').prop('disabled', false);
          yext.dam.assetselector.video.updateSelected(video);
        } catch (e) {
          onError();
        }
      }, yext.ajax.errorWrapper(onError));
    } else {
      $preview.empty();
    }
  }
};

/**
 * updateAsset stores the video info into the selected asset
 *
 * @param {Video} video object from youtube.js
 */
yext.dam.assetselector.video.updateSelected = function(video) {
  $(yext.dam.assetselector.video).trigger('videoSelected', video);
};

/**
 * Reset youtube preview
 */
yext.dam.assetselector.video.clearPreview = function() {
  yext.dam.assetselector.video.$selector.find('.js-video-preview-panel').show();

  yext.dam.assetselector.video.$preview
    .data('ytid', '')
    .hide()
    .find('iframe')
    .attr('src', '');

  yext.dam.assetselector.video.$previewMessage.show();
};

/**
 * Binds youtube input listener
 */
yext.dam.assetselector.video.bindEnterVideo = function() {
  yext.dam.assetselector.video.$selector.find('input[name="video.value"]')
    .each(function() {
      yext.dam.assetselector.video.updatePreview($(this).val());
    })
    .inputchange(function() {
      yext.dam.assetselector.video.updatePreview($(this).val());
    });
};
